<div class="relative h-full">
  <div class="absolute inset-0 top-0 w-full">
    <div class="flex h-full gap-4">
      <div class="z-10 h-16 flex-1 bg-white">
        <app-multimedia-grid-filter
          (uploadClickEvent)="handleUploadClickEvent()"
          (filterChange)="handleFilterChange($event)"
          uploadButtonLabel="Prześlij pliki" />
      </div>

      <div class="z-10 flex h-full w-100 flex-col bg-gray-50 p-6">
        @if (selected() | adminFetchMultimediaById | async; as selected) {
          <app-multimedia-attributes [multimedia]="selected" />
        }

        <div class="mt-auto flex justify-end">
          <p-button
            (onClick)="handleChooseClick()"
            [disabled]="!isSelected()"
            appPrimengButton
            label="Wybierz"
            severity="primary" />
        </div>
      </div>
    </div>
  </div>

  <div class="absolute inset-0 -ml-4 overflow-y-auto pt-16 pr-100 pl-4">
    <div class="flex">
      <div class="w-full">
        <app-multimedia-grid
          (selectionChangeEvent)="handleSelectionChangeEvent($event)"
          [loadOnInit]="false"
          [multi]="false"
          mode="select"
          templateColumns="sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 2xl:grid-cols-8" />
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="uploadDialogVisibility"
  [style]="{ width: '80vw', maxWidth: '90rem' }"
  appPrimengDialog
  header="Prześlij pliki">
  @if (uploadDialogVisibility) {
    <div class="pt-1">
      <app-multimedia-upload (uploadedEvent)="handleUploadedEvent()" />
    </div>
  }

  <ng-template #footer>
    <div class="flex justify-end">
      <p-button
        (onClick)="handleUploadCloseClickEvent()"
        appPrimengButton
        label="Zamknij" />
    </div>
  </ng-template>
</p-dialog>
